module.exports = __webpack_public_path__ + "img/loginpanel1.3fc98a09.png";